import Report from '../Report';
import CompositeReport from '../CompositeReport';
import {t} from 'shared/core';

const filters = [
  'Department',
  'Employee',
  'Expense Status',
  'Location',
  'Manager'
];

const ExpensesReport = () => {
  return (
    <CompositeReport dateFilter='range' filters={filters}>
      <Report name={t('reports.EXPENSES_REPORT')}
        url='/reports/expenses'>
      </Report>
    </CompositeReport>
  );
};

export default ExpensesReport;
